import { useCallback, useMemo } from 'react';
import { useGuestCartStore } from '../store/useGuestCartStore';
import { cartSubtotal, computeDiscount, computeTax, lineTotal, lineUnitPrice } from '../utils/cartMath';
import { toNumber, round2 } from '../utils/money';

export function useGuestCart() {
  const restaurant = useGuestCartStore((s) => s.restaurant);
  const lines = useGuestCartStore((s) => s.lines);
  const coupon = useGuestCartStore((s) => s.coupon);
  const fee = useGuestCartStore((s) => s.fee);
  const ui = useGuestCartStore((s) => s.ui);
  const actions = useGuestCartStore((s) => s.actions);

  const totals = useMemo(() => {
    const subtotal = cartSubtotal(lines);
    const discount = computeDiscount(subtotal, coupon);
    const taxedBase = Math.max(0, subtotal - discount);
    const tax = computeTax(taxedBase, fee?.taxRatePct || 0);
    const delivery = Math.max(0, toNumber(fee?.delivery, 0));
    const total = round2(taxedBase + tax + delivery);
    return { subtotal, discount, tax, delivery, total };
  }, [lines, coupon, fee]);

  const itemCount = useMemo(() => lines.reduce((n, l) => n + Math.max(0, toNumber(l?.qty, 0)), 0), [lines]);

  const getLinePricing = useCallback((line) => {
    const unit = lineUnitPrice(line);
    const total = lineTotal(line);
    return { unit, total };
  }, []);

  return {
    restaurant,
    lines,
    coupon,
    fee,
    ui,
    actions,
    totals,
    itemCount,
    getLinePricing,
    hasItems: lines.length > 0,
  };
}

